// 这个工具有问题，ws存储在window下
// 当一个页面中多次使用此工具就会出现覆盖问题
// 建议调整为 Class 方式实现
// 具体可以参照 websocket.new.js 文件

import * as Sentry from "@sentry/vue";
import { getWsUrl, getWsUrlList } from "@/utils/apiHost";

let isClose = false;

let lastSendMsg = ""; // 最后一次订阅的信息

let websock = null;
let rec; //断线重连后，延迟5秒重新创建WebSocket连接  rec用来存储延迟请求的代码
let isConnect = false; //连接标识 避免重复连接


const WS_TICK_PATH = "/tick";
let wsBaseURLList = [];
let wsBaseURL = "";
let wsBaseURLListIndex = 0;

/** 连接前同步 WS 地址（避免模块加载早于 loadAppConfig 时用错 config.js 默认值） */
function syncWsBaseUrlsFromConfig() {
  wsBaseURLList = getWsUrlList(WS_TICK_PATH);
  if (!wsBaseURLList.length) {
    wsBaseURL = getWsUrl(WS_TICK_PATH);
    return;
  }
  if (wsBaseURLListIndex >= wsBaseURLList.length) {
    wsBaseURLListIndex = 0;
  }
  wsBaseURL = wsBaseURLList[wsBaseURLListIndex] || wsBaseURLList[0];
}

// 心跳
// eslint-disable-next-line @typescript-eslint/no-unused-vars
let heartbeatInter = "";
const heartbeat = () => {
  if(heartbeatInter){
    clearTimeout(heartbeatInter);
  }
  if(websock && websock.send){
    websock.send("ping");
    heartbeatInter = setTimeout(() => {
      // websock.send("ping");
      heartbeat();
    }, 30 * 1000);
  }
};

let globalCallback = function() {};

const createWebSocket = () => {
  try {
    // var ws = window.$config.VUE_BASE_SOCKET;
    // websock = new WebSocket(ws);
    // eslint-disable-next-line no-undef,@typescript-eslint/no-use-before-define
    initWebSocket(); //初始化websocket连接
  } catch (e) {
    // 
    // eslint-disable-next-line no-undef,@typescript-eslint/no-use-before-define
    reConnect(); //如果无法连接上webSocket 那么重新连接！可能会因为服务器重新部署，或者短暂断网等导致无法创建连接
  }
};

//定义重连函数
const reConnect = () => {
  // 
  if (isConnect) return; //如果已经连上就不在重连了
  rec && clearTimeout(rec);
  rec = setTimeout(function() {
    // 延迟5秒重连  避免过多次过频繁请求重连
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    if(wsBaseURLList && wsBaseURLList.length > 0){
      wsBaseURL = wsBaseURLList[wsBaseURLListIndex];
      wsBaseURLListIndex++;
      if(wsBaseURLListIndex >= wsBaseURLList.length){
        wsBaseURLListIndex = 0;
      }
    }
    // 
    createWebSocket();
  }, 1000);
};
//设置关闭连接
const closeWebSocket = () => {
  lastSendMsg = ""; // 自己关闭的 删除记录
  isClose = true;
  websock.close();
};

const openWebSocket = () => {
  syncWsBaseUrlsFromConfig();
  // eslint-disable-next-line no-undef,@typescript-eslint/no-use-before-define
  initWebSocket();
};

// 发送订阅的时候，开始计时
// 接收到消息的时候，先关闭计时，再开启
let WSReportInter = null;
let lastSendData;
const WSReportInterFn = (agentData = "", data) => {
  if (!lastSendData) {
    lastSendData = agentData ? agentData : lastSendData;
  }
  WSReportInter = setTimeout(() => {
    const times = String(new Date());
    try {
      Sentry.captureMessage("websocket_tick_error", {
        level: "info",
        extra: {
          type: "websocket_tick_error",
          lastSendData,
          msg: !data ? "一次都没推。" : `推送了，但是${window.$config.WS_CHECK_TICK_TIME}毫秒后，没推了。`,
          lastData: JSON.stringify(data),
          times,
          url: wsBaseURL,
          WS_CHECK_TICK_TIME: window.$config.WS_CHECK_TICK_TIME
        }
      });
      // 
      // 检查是否有未发送的信息 有的话 重新订阅一下
      if (lastSendMsg) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        sendSock(lastSendMsg);
        // 
      }
    } catch (err) {
      // ignore
    }
    // 递归处理轮询
    WSReportInterFn(agentData, data);
  }, window.$config.WS_CHECK_TICK_TIME);
};
// 初始化websocket
function initWebSocket() {
  syncWsBaseUrlsFromConfig();
  // ws地址 -->这里是你的请求路径
  // let uName = localStorage.getItem("uName")

  websock = new WebSocket(wsBaseURL);
  websock.onmessage = function(e) {
    if (e.data && e.data != "pong") {
      // 收到信息就先关了
      clearTimeout(WSReportInter);
      // eslint-disable-next-line no-undef,@typescript-eslint/no-use-before-define
      websocketonmessage(e);
      WSReportInterFn("", JSON.parse(e.data)); // 重新二次开启
    }
  };
  websock.onclose = function(e) {
    if(!isClose){
      // eslint-disable-next-line no-undef,@typescript-eslint/no-use-before-define
      websocketclose(e);
      // 
    }

  };
  websock.onopen = function() {
    isClose = false;
    // 
    // 重试成功后记录当前可用 WS 完整地址
    window.$config.__WS_TICK_URL = wsBaseURL;
    // 检查是否有未发送的信息
    if (lastSendMsg) {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      sendSock(lastSendMsg);
    }
    // eslint-disable-next-line no-undef,@typescript-eslint/no-use-before-define
    websocketOpen();
  };

  // 连接发生错误的回调方法
  websock.onerror = function(e) {
    // 
    // 
    isConnect = false; //连接断开修改标识
    reConnect(); //连接错误 需要重连
    Sentry.captureMessage("websocket_error", {
      level: "error",
      extra: {
        type: "websocket_error",
        message: "websocket连接失败！",
        url: wsBaseURL,
        date: String(new Date())
      }
    });
  };
}

// 实际调用的方法
function sendSock(agentData, callback) {
  // 记录最近一次发送的消息 重连的时候 重新订阅
  lastSendMsg = agentData;
  // globalCallback = callback
  if (websock.readyState === websock.OPEN) {
    // 若是ws开启状态
    // eslint-disable-next-line no-undef,@typescript-eslint/no-use-before-define
    websocketsend(agentData);
  } else if (websock.readyState === websock.CONNECTING) {
    // 若是 正在开启状态，则等待1s后重新调用
    setTimeout(function() {
      sendSock(agentData, callback);
    }, 1000);
  } else {
    // 若未开启 ，则等待1s后重新调用
    setTimeout(function() {
      sendSock(agentData, callback);
    }, 1000);
  }
}

function getSock(callback) {
  globalCallback = callback;
}

// 数据接收
function websocketonmessage(e) {
  globalCallback(JSON.parse(e.data));
}

// 数据发送
function websocketsend(agentData) {
  clearTimeout(WSReportInter); // 优先清除一下计时器
  websock.send(JSON.stringify(agentData));
  // 指定时间内，未收到信息，则执行相关逻辑
  // 开始计时
  WSReportInterFn(agentData, "");
}

// 关闭
function websocketclose(e) {
  clearTimeout(heartbeatInter);
  // 
  isConnect = false; //断开后修改标识
  reConnect();
  // 
}

// 创建 websocket 连接
function websocketOpen() {
  isConnect = true;
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  heartbeat(); // 开启心跳
  sessionStorage.setItem("isopen", true);
  // 
}
// 测试断开
// setInterval(() => {
//   websocketclose({ code: 1006 });
// }, 1000 * 10);
// initWebSocket()

// 将方法暴露出去
export { sendSock, getSock, createWebSocket, closeWebSocket, openWebSocket };
